export default class EventCosts {
    id: number
    eventId: number
    expenditureAmount: number
    expenditureDescription: string
    [key: string]: any
}